/**
 * 2D footprint adapter — delegates to the families system.
 *
 * PropLayer imports this for the interactive plan symbols. The prop model now uses
 * familyId + params; this thin adapter extracts those and forwards to FamilyFootprint2D.
 */
import type { Prop } from '@/model/types'
import { FamilyFootprint2D, PROP_STROKE } from '@/components/families/footprints'

export { PROP_STROKE }

/** Render the top-down footprint for `prop`. Drawn in local prop space (origin = center). */
export function Footprint2D({ prop, scale }: { prop: Prop; scale: number }) {
  return (
    <FamilyFootprint2D
      familyId={prop.familyId}
      params={prop.params}
      scale={scale}
    />
  )
}
